









import {Component, Prop, Vue} from 'vue-property-decorator';
import JdhSizeDetector from "@/design-system/shared/JdhSizeDetector.vue"
import {ActiveProvide} from "@/support/reactive"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 * @changelog 4.4.0 Switched to a single, flexible column, and supporting stacked section layouts.
 * @changelog 4.5.4 Force to stacking mode when the page will otherwise overflow, to prioritize legibility over all else.
 * @changelog 4.8.8 Allow relative-width children when stacking, by setting a min width on the grid column.
 * @changelog 4.9.1 Ensure a minimum width exists on grid elements, allowing relative widths on children.
 */
@Component({
    components: {JdhSizeDetector}
})
export default class JdsPageLayout extends Vue {
    @Prop({default: false, type: Boolean}) centered!: boolean;
    @Prop({default: false, type: Boolean}) fullWidth!: boolean;

    @ActiveProvide('jds.page-layout.stack') stacking = false;

    forcedToStack = false

    onResize(rect: DOMRect) {
        this.stacking = rect.width < 800;
    }

    get shouldStack () {
        return this.stacking || this.forcedToStack
    }

}
